.wrapper {
    --code-block-line-numbers-width: 1ch;

    position: relative;
}

.wrapper[data-with-line-numbers] :global(.mantine-CodeHighlight-code) {
    padding-inline-start: calc(
        var(--mantine-spacing-md) * 2 + var(--code-block-line-numbers-width)
    );
}

.lineNumbers {
    position: absolute;
    z-index: 1;
    top: var(--mantine-spacing-xs);
    inset-inline-start: var(--mantine-spacing-md);
    width: var(--code-block-line-numbers-width);
    color: var(--mantine-color-dimmed);
    font-family: var(--mantine-font-family-monospace);
    font-size: calc(0.8125rem * var(--mantine-scale));
    line-height: 1.7;
    text-align: end;
    white-space: pre;
    pointer-events: none;
    user-select: none;
}
